<template>
  <h1>Persönliche Daten</h1>
  <ion-row>
    <ion-col size="12" size-md>
      <ion-item lines="none">
        <ion-label position="stacked">Vorname</ion-label>
        <ion-input
          placeholder="Vorname"
          v-model="formInput['Firstname']"
        ></ion-input>
      </ion-item>
      <input-error id="Firstname" />
    </ion-col>
    <ion-col size="12" size-md>
      <ion-item lines="none">
        <ion-label position="stacked">Nachname</ion-label>
        <ion-input
          placeholder="Nachname"
          v-model="formInput['Lastname']"
        ></ion-input>
      </ion-item>
      <input-error id="Lastname" />
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12" size-md>
      <ion-item lines="none">
        <ion-label position="stacked">Versicherungsnummer</ion-label>
        <ion-input
          placeholder=""
          v-model="formInput['ExternalId']"
        ></ion-input>
      </ion-item>
      <input-error id="ExternalId" />
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12" size-md>
      <ion-item lines="none">
        <ion-label position="stacked">Email Addresse</ion-label>
        <ion-input
          placeholder="adresse@mail.com"
          v-model="formInput['Email']"
        ></ion-input>
      </ion-item>
      <input-error id="Email" />
    </ion-col>
    <ion-col size="12" size-md>
      <ion-item lines="none">
        <ion-label position="stacked">Mobilnummer</ion-label>
        <ion-input
          placeholder="+49XXXXXXXXXX"
          v-model="formInput['Msisdn']"
        ></ion-input>
      </ion-item>
      <input-error id="Msisdn" />
    </ion-col>
  </ion-row>
  <next-question-button @click="emitValues" :disabled="isFormInputEmpty" />
</template>

<script>
import { IonRow, IonCol, IonItem, IonLabel, IonInput } from "@ionic/vue";
import InputError from "@arag/components/InputError";
import NextQuestionButton from "./NextQuestionButton";
import { apiGetUser } from "@arag/api/user";

export default {
  components: {
    IonRow,
    IonCol,
    IonItem,
    IonLabel,
    IonInput,
    InputError,
    NextQuestionButton,
  },
  emits: ["done"],
  props: {
    question: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      formInput: {
        Firstname: "",
        Lastname: "",
        ExternalId: "",
        Email: "",
        Msisdn: "",
      },
    };
  },
  mounted() {
    apiGetUser().then(() => {
      this.formInput.Firstname = this.$store.state.user.FirstName;
      this.formInput.Lastname = this.$store.state.user.LastName;
      this.formInput.ExternalId = this.$store.state.user.ExternalId;
      this.formInput.Email = this.$store.state.user.Email;
      this.formInput.Msisdn = this.$store.state.user.Msisdn;
    });
  },
  computed: {
    isFormInputEmpty() {
      for (const formInputKey in this.formInput) {
        if (this.formInput[formInputKey] === "") {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    emitValues() {
      const value = `
        Vorname: ${this.formInput.Firstname}<br />
        Nachname: ${this.formInput.Lastname}<br />
        Vertragsnummer: ${this.formInput.ExternalId}<br />
        Email Addresse: ${this.formInput.Email}<br />
        Mobilnummer: ${this.formInput.Msisdn}
        `;
      this.$emit("done", {
        value: value,
        id: this.question.id,
      });
    },
  },
};
</script>

<style></style>
